<template>
 <div class="loader" >
   <div class="spinner-border bolder" role="status"/>
  </div>
</template>
<script>
export default {
  name: 'loader',
  props: ['visible']
}
</script>
<style>
</style>
